module.exports = "/packs/images/navigation/blue-ribbon-0b88c5449a9f647b7f11acc78f54af58.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/blue-ribbon.jpg
// module id = 1818
// module chunks = 0